export const ACENDING = 'ASC'
export const DESCENDING = 'DESC'

export const SORT = {
  ARTICLES: 'article.created',
  ATTACHMENTS: 'file_name',
  CATEGORIES: 'name',
  DISCOVERIES: 'article.created',
  SEARCH: 'article.pinned',
  USER: 'first_name',
  WEBPAGE: 'article.created'
}

export const EXPORT_REQUEST_SIZE = 10
